import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class Theatre extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);
		if (data) {
			this.data = {entreChaise: 0.50, entreRange: parseFloat(data.er), rangeOffset: parseFloat(data.ro), 
				praticable: (data.p == "true"), switchOrientation: (data.so == "true"), isEcranMural: (data.em == "true")};
		}
		else {
			this.data = {entreChaise: 0.50, entreRange: 1, rangeOffset: 0, praticable: false, switchOrientation: false, isEcranMural: false};
		}
		
		this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName + "_T");
		if (!(this.grandEcranObject)) {
			this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName);
		}
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);
		this.praticableObject = this.currentEnv.getObjectByName("Praticable_" + this.roomName);
		this.tableOrateurObject = this.currentEnv.getObjectByName("Orateur_" + this.roomName);
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);

		this.roomWithDifferentPlacement = ["1", "2", "3", "4", "8", "9", "10"];
	}

	Show() {
		if (!this.refPraticable) {
			this.CreatePraticable();
		}
		else if(!this.refGrandEcran) {
			this.CreateGrandEcran();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refChaise) {
			this.CreateChaise();
		}
		else if(!this.refTableOrateur) {
			this.CreateTableOrateur();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var currentPraticables = [];
			var currentGrandEcran = [];
			var currentSortieSecours = [];
			var currentPlafonnier = [];
			var currentChaises = [];
			var currentTableOrateur = [];

			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Praticable") {
					currentPraticables.push(this.whereToAddObjects.children[i]);
					if (this.data.praticable) {
						this.whereToAddObjects.children[i].visible = true;
					}
					else {
						this.whereToAddObjects.children[i].visible = false;
					}
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentPraticables.length;
				}

				if (this.whereToAddObjects.children[i].name == "Grand_Ecran") {
					currentGrandEcran.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentGrandEcran.length;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Table_Reunion") {
					currentTableOrateur.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Chaise_Bleue") {
					currentChaises.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = true;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentChaises.length;

				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}
			
			if (this.data.praticable) {
				var praticablePos;
				if (this.roomConfig == "1" && this.data.switchOrientation) {
					praticablePos = this.praticableObject.getObjectByName("1_2");
				}
				else {
					praticablePos = this.praticableObject.getObjectByName(this.roomConfig);
				}
				if (praticablePos) {
					for (var i = 0; i < praticablePos.children.length; i++) {
						if (i < currentPraticables.length)
							this.objectGenerator.ApplyTransform(currentPraticables[i], {refObject: praticablePos.children[i]});
						else {
							currentPraticables.push(this.objectGenerator.CloneElement(this.refPraticable, this.whereToAddObjects, {refObject: praticablePos.children[i]}));
							currentPraticables[currentPraticables.length - 1].simsData.id = currentPraticables.length;
						}
					}
				}
				else {
					for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
						if (this.whereToAddObjects.children[i].name == "Praticable") {
							this.whereToAddObjects.children[i].visible = false;
						}
					}
				}
			}
			var nbEcrans = 0;
			var grandEcranPos = this.grandEcranObject.getObjectByName("Screen_" + this.roomConfig + "_T");
			if (!(grandEcranPos)) {
				grandEcranPos = this.grandEcranObject.getObjectByName("Screen_" + this.roomConfig);
			}
			if (grandEcranPos) {
				if (grandEcranPos.children.length) {
					if ((this.roomConfig == "1" && !this.data.switchOrientation) || this.roomConfig == "3") {
						for (var i = 0; i < grandEcranPos.children.length; i++) {
							if ((this.data.praticable && grandEcranPos.children[i].name.includes("Prat")) ||
								(!this.data.praticable && !grandEcranPos.children[i].name.includes("Prat"))) {
								if (nbEcrans < currentGrandEcran.length) {
									this.objectGenerator.ApplyTransform(currentGrandEcran[nbEcrans], {refObject: grandEcranPos.children[i]});
									currentGrandEcran[nbEcrans].visible = true;
									nbEcrans++;
								}
								else {
									currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos.children[i]}));
									currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
									nbEcrans++;
								}
							}
						}
					}
					else if (this.roomConfig != "1") {
						for (var i = 0; i < grandEcranPos.children.length; i++) {
							if (i < currentGrandEcran.length) {
								this.objectGenerator.ApplyTransform(currentGrandEcran[i], {refObject: grandEcranPos.children[i]});
								currentGrandEcran[i].visible = true;
							}
							else {
								currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos.children[i]}));
								currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
							}
						}
					}
				}
				else {
					if (currentGrandEcran.length >= 1) {
						this.objectGenerator.ApplyTransform(currentGrandEcran[0], {refObject: grandEcranPos});
						currentGrandEcran[0].visible = true;
					}
					else {
						currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos}));
						currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
					}
				}
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
			if (plafonnierPos) {
				if (currentPlafonnier.length >= 1) {
					this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
					if (this.data.isEcranMural) {
						currentPlafonnier[0].visible = true;
					}
				}
				else {
					this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
				}
			}

			if (this.tableOrateurObject && !this.data.praticable) {
				var tableOrateurPos = this.tableOrateurObject.getObjectByName("Orateur_" + this.roomConfig);
				if (this.roomConfig == "1" && this.data.switchOrientation) {
					tableOrateurPos = this.tableOrateurObject.getObjectByName("Orateur_" + this.roomConfig + "_Bis");
				}
				if (tableOrateurPos) {
					if (currentTableOrateur.length >= 1) {
						this.objectGenerator.ApplyTransform(currentTableOrateur[0], {refObject: tableOrateurPos});
						currentTableOrateur[0].visible = true;
					}
				}
			}

			var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
			var zoneDelimData = this.SetupDelimData(delim);

			var chaiseCount = 0;
			chaiseCount = this.Generate(zoneDelimData, currentChaises, currentPraticables, chaiseCount);

			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
			if (currentChaises.length > chaiseCount) {
				this.HideObjectAdded(currentChaises, chaiseCount);
			}
			this.data.type = "Theatre";
			this.data.chaiseCount = chaiseCount;
		}
	}

	ShowLully() {
		var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
		if (distancePos) {
			this.CreateDistances(distancePos);
		}
	}

	AnimateLully(dt, todo) {
		this.isOpen.tribune = !todo;
		if (todo) {
			this.isAnimate = true;
			return this.OpenTribune((dt) * -1);
		}
		else {
			this.isAnimate = true;
			return this.CloseTribune(dt);
		}
	}

	Generate(zoneDelimData, currentChaises, currentPraticables, chaiseCount) {
		var chaiseRotation = 0;
		var currentZoneDelimData;
		if (zoneDelimData.length > 1) {
			currentZoneDelimData = zoneDelimData[0];
		}
		else {
			currentZoneDelimData = zoneDelimData;
		}

		currentZoneDelimData.entreRangeMin = currentZoneDelimData.minX;
		currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxX;
		currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minZ;
		currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxZ;

		switch(this.roomConfig) {
			case "1_2":
			case "1_2_3":
				currentZoneDelimData.entreRangeMax -= 6;
				currentZoneDelimData.entreRangeMin += 2;
				currentZoneDelimData.entreChaiseMin += 1;
				currentZoneDelimData.entreChaiseMax -= 1;
				chaiseRotation = Math.PI/2;
				break;
			case "1":
				if (this.data.switchOrientation) {
					currentZoneDelimData.entreRangeMin += 1;
					currentZoneDelimData.entreRangeMax -= 3;
					currentZoneDelimData.entreChaiseMin += 1.5;
					currentZoneDelimData.entreChaiseMax -= 1.5;
					chaiseRotation = Math.PI/2;
				}
				else {
					currentZoneDelimData.entreRangeMin = currentZoneDelimData.minZ + 4;
					currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxZ - 1;
					currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minX + 1;
					currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxX - 1;
					chaiseRotation = Math.PI;
				}
				break;
			case "2":
				currentZoneDelimData.entreRangeMin = currentZoneDelimData.minZ + 5;
				currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxZ - 1;
				currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minX + 1.5;
				currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxX - 1.5;
				chaiseRotation = Math.PI;
				break;
			case "3":
				currentZoneDelimData.entreRangeMin = currentZoneDelimData.minZ + 4;
				currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxZ - 1;
				currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minX + 1;
				currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxX - 1;
				chaiseRotation = Math.PI;
				break;
			case "2_3":
				currentZoneDelimData.entreRangeMin += 4;
				currentZoneDelimData.entreRangeMax -= 1;
				currentZoneDelimData.entreChaiseMin += 1;
				currentZoneDelimData.entreChaiseMax -= 1;
				chaiseRotation = -Math.PI/2;
				break;
			case "4":
				currentZoneDelimData.entreRangeMin = currentZoneDelimData.minZ + 1.5;
				currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxZ - 2.5;
				currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minX + 1;
				currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxX - 1;
				chaiseRotation = Math.PI * 2;
				break;
			case "8":
			case "9":
			case "10":
				currentZoneDelimData.entreRangeMin = currentZoneDelimData.minZ + 2.5;
				currentZoneDelimData.entreRangeMax = currentZoneDelimData.maxZ - 1;
				currentZoneDelimData.entreChaiseMin = currentZoneDelimData.minX + 1;
				currentZoneDelimData.entreChaiseMax = currentZoneDelimData.maxX - 1;
				chaiseRotation = Math.PI;
				if (zoneDelimData.length > 1) {
					var dataToInvert = {};
					for (var i = 1; i < zoneDelimData.length; i++) {
						dataToInvert = structuredClone(zoneDelimData[i]);
						zoneDelimData[i].maxX = dataToInvert.maxZ;
						zoneDelimData[i].minX = dataToInvert.minZ;
						zoneDelimData[i].maxZ = dataToInvert.maxX;
						zoneDelimData[i].minZ = dataToInvert.minX;
					}
				}
				break;
			case "5":
			case "6":
				currentZoneDelimData.entreRangeMin += 1;
				currentZoneDelimData.entreRangeMax -= 2.5;
				currentZoneDelimData.entreChaiseMin += 1;
				currentZoneDelimData.entreChaiseMax -= 1;
				chaiseRotation = Math.PI / 2;
				break;
			case "7":
				currentZoneDelimData.entreRangeMin += 1;
				currentZoneDelimData.entreRangeMax -= 3.5;
				currentZoneDelimData.entreChaiseMin += 1;
				currentZoneDelimData.entreChaiseMax -= 1;
				chaiseRotation = Math.PI / 2;
				break;
			case "11":
				currentZoneDelimData.entreRangeMin += 3.5;
				currentZoneDelimData.entreRangeMax -= 1.5;
				currentZoneDelimData.entreChaiseMin += 1;
				currentZoneDelimData.entreChaiseMax -= 1;
				chaiseRotation = -Math.PI / 2;
				break;
		}

		var currentEntreChaise = Math.floor((currentZoneDelimData.entreChaiseMax - currentZoneDelimData.entreChaiseMin) / Math.floor((currentZoneDelimData.entreChaiseMax - currentZoneDelimData.entreChaiseMin)/this.data.entreChaise) * 10000) / 10000;

		var currentNbChaiseRange;

		var nbChaiseRange = Math.ceil((currentZoneDelimData.entreChaiseMax - currentZoneDelimData.entreChaiseMin) / this.data.entreChaise);
		var espaceCentrale = 2;
		
		if (this.data.entreChaise >= 0.70) {
			espaceCentrale = 1;
		}
		else if (this.data.entreChaise >= 0.60) {
			espaceCentrale = 1.5;
		}

		if (this.data.rangeOffset < -(nbChaiseRange / 2)) {
			this.data.rangeOffset = -(nbChaiseRange / 2);
		}
		else if (this.data.rangeOffset > nbChaiseRange / 2) {
			this.data.rangeOffset = nbChaiseRange / 2;
		}

		var newPos = {};
		for (var i = currentZoneDelimData.entreRangeMin; i < currentZoneDelimData.entreRangeMax; i += this.data.entreRange) {
			currentNbChaiseRange = 0;
			for (var j = currentZoneDelimData.entreChaiseMin; j < currentZoneDelimData.entreChaiseMax; j += currentEntreChaise) {
				if (this.roomConfig == "4" || this.roomConfig == "11" || 
					(currentNbChaiseRange < (nbChaiseRange / 2) - (espaceCentrale / 2) + this.data.rangeOffset 
						|| currentNbChaiseRange >= (nbChaiseRange / 2) + (espaceCentrale / 2) + this.data.rangeOffset)) {
					newPos.posX = i;
					newPos.posZ = j;
					if (!this.IsInZone(zoneDelimData, newPos)) {

						if (chaiseCount < currentChaises.length) {
							if (this.roomWithDifferentPlacement.includes(this.roomConfig) && (this.roomConfig != "1" || (this.roomConfig == "1" && !this.data.switchOrientation))) {
								this.objectGenerator.ApplyTransform(currentChaises[chaiseCount], {posX: j, posZ: i, rotY: chaiseRotation});
							}
							else {
								this.objectGenerator.ApplyTransform(currentChaises[chaiseCount], {posX: i, posZ: j, rotY: chaiseRotation});
							}
						}
						else {
							if (this.roomWithDifferentPlacement.includes(this.roomConfig) && (this.roomConfig != "1" || (this.roomConfig == "1" && !this.data.switchOrientation))) {
								currentChaises.push(this.objectGenerator.CloneElement(this.refChaise, this.whereToAddObjects, {posX: j, posZ: i, rotY: chaiseRotation}));
							}
							else {
								currentChaises.push(this.objectGenerator.CloneElement(this.refChaise, this.whereToAddObjects, {posX: i, posZ: j, rotY: chaiseRotation}));
							}
							currentChaises[currentChaises.length - 1].simsData.id = currentChaises.length;
						}

						chaiseCount++;
					}
				}

				currentNbChaiseRange++;
			}
		}
		
		return chaiseCount;
	}

	Modify(value) {
		if (value.type == "entreChaise") {
			this.data.entreChaise = parseFloat(value.value);
		}
		else if (value.type == "entreRange") {
			this.data.entreRange = parseFloat(value.value);
		}
		else if (value.type == "praticable") {
			this.data.praticable = value.value;
		}
		else if (value.type == "switchOrientation") {
			this.data.switchOrientation = value.value;
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		else if (value.type == "rangeOffset") {
			this.data.rangeOffset += value.value;
		}

		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
	}

	CreateChaise() {
		this.refChaise = this.whereToAddObjects.getObjectByName("Chaise_Bleue");
		if (this.refChaise){
			this.refChaise.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateChaise();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Chaise_Bleue", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePraticable() {
		this.refPraticable = this.whereToAddObjects.getObjectByName("Praticable");
		if (this.refPraticable) {
			this.refPraticable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePraticable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Praticable", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateGrandEcran() {
		this.refGrandEcran = this.whereToAddObjects.getObjectByName("Grand_Ecran");
		if (this.refGrandEcran) {
			this.refGrandEcran.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateGrandEcran();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Grand_Ecran", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateTableOrateur() {
		this.refTableOrateur = this.whereToAddObjects.getObjectByName("Table_Reunion");
		if (this.refTableOrateur){
			this.refTableOrateur.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateTableOrateur();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Table_Reunion", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}
/*
	ResetBaseConfig() {
		this.theatreData = {entreChaise: 0.50, entreRange: 1, praticable: false};
	}*/
}